import axios from "axios";

import { IP } from "../utils/Host";


export function updateZmienCzasTrwaniaGrupy(drop_grupa_global_id,nowy_koniec,fechGrupyAndWykonaniaForProcesor) {

// id = procesor id

  axios.get(IP + "zmienCzasTrwaniaGrupy/"+drop_grupa_global_id+"/"+nowy_koniec+"/" + sessionStorage.getItem("token"))
    .then((res) => {

      console.log("grupa_global_id: "+drop_grupa_global_id)
      console.log("nowy_koniec: "+nowy_koniec)
    // console.log("procesor " +res.data[0].mcr)
    // fechparametryTechnologii
    fechGrupyAndWykonaniaForProcesor(res.data[0].procesor_id)

    });
}
